import axios from 'axios';
import store from '@/store';
import router from '@/routes';

//console.log('axios console', process.env, window.location.hostname);
// if (process.env == 'test') {
// 	axios.defaults.baseURL = process.env.VUE_APP_API_URL.replace('hair-', window.location.hostname + '-');
// 	console.log(axios.defaults.baseURL);
// } else {
// 	axios.defaults.baseURL = process.env.VUE_APP_API_URL;
// }

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.withCredentials = true;
axios.defaults.headers.common = {
	'Access-Control-Allow-Origin': '*',
	'Content-Type': 'application/json; charset = utf-8',
};
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// #3252 : 조회 전용 거부인지 판정한다. 세 조건이 모두 맞아야 한다.
// 하나라도 어긋나면 기존 403 처리를 그대로 따른다.
function isStateScopeDenied(response) {
	try {
		// vue-session 은 persist 옵션에 따라 localStorage 또는 sessionStorage 를 쓴다.
		// 어느 쪽인지 옵션을 따라가지 않고 둘 다 본다.
		const raw = window.localStorage.getItem('vue-session-key') || window.sessionStorage.getItem('vue-session-key') || '{}';
		const sessionUser = JSON.parse(raw).user;
		if (!sessionUser || sessionUser.company_id !== 'beautyplus') return false;
		const header = response.headers && response.headers['x-state-scope-denied'];
		const code = response.data && response.data.code;
		return header === 'STATE_SCOPE_FORBIDDEN' && code === 'STATE_SCOPE_FORBIDDEN';
	} catch (e) {
		return false;
	}
}

function setInterceptors(instance, show_loading_icon) {
	instance.interceptors.request.use(
		config => {
			//config.headers.Authorization = store.state.token;
			if (show_loading_icon) store.commit('setLoading', true);
			//config.headers.common['X-AUTH-TOKEN'] = store.state.token;
			return config;
		},
		error => {
			//console.log('Axios request error', error);
			if (show_loading_icon) store.commit('setLoading', false);
			Promise.reject(error.response);
		},
	);

	instance.interceptors.response.use(
		response => {
			if (show_loading_icon) store.commit('setLoading', false);
			return response;
			/*
			if (!response.headers.company_id) return response;

			console.log(response.headers.company_id, window.location.host.split('.')[0]);

			var url_host = window.location.host.split('.')[0];

			if (url_host == 'demo3') url_host = 'demo';

			if (url_host.startsWith('localhost') || response.headers.company_id == url_host) return response;

			window.location = '/login?sessionExpired=true&backUri=/'; */
		},
		error => {
			console.log(error);
			if (show_loading_icon) store.commit('setLoading', false);
			if (!error.response) {
				//console.log('Network Error');
				//this.$toast.success('Network Error');
				router.push({ name: 'error', params: { message: 'Network Error' } });
			} else {
				// #3252 : State 조회 제한이 낸 거부는 세션 만료가 아니다. 다시 로그인시키면
				// 사용자가 영문도 모르고 로그인 화면으로 튕긴다. 회사·body code·header 가 모두
				// 정확히 맞을 때만 재로그인을 건너뛰고, 그 밖의 403 은 종전대로 세션 복구로 보낸다.
				if (error.response.status === 403 && isStateScopeDenied(error.response)) {
					return Promise.reject(error);
				}
				if (error.response.status === 403) {
					//if (store.getters['isLoggedIn']) alert('세션이 종료되어 다시 로그인합니다.');
					//store.commit('delToken');
					//router.push({ name: 'login', params: { sessionExpired: true } });
					//router.push({ name: 'login', params: { sessionExpired: true } });
					//router.push('/login');
					//alert(window.location.pathname);
					window.location = '/login?sessionExpired=true&backUri=' + window.location.pathname;
				} else {
					//console.log(error);
					router.push({ name: 'error', params: { message: error } });
				}
			}

			return Promise.reject(error);
		},
	);
	return instance;
}

const api = axios.create();
setInterceptors(api, true);

const session_api = axios.create();
setInterceptors(session_api, false);

export function apiHome() {
	return api.get('/api/home');
}

export function apiTest() {
	return api.get('/api/test');
}

// export function apiUps(param) {
// 	return api.post('/api/ups', param);
// }

export function apiSessionCheck() {
	return session_api.get('/api/global_session_check');
}

export function apiSystemMessage() {
	return session_api.get('/api/system_message');
}

export function apiInsertGoogleApiLog(param) {
	return session_api.post('/api/report/insertGoogleApiLog', param);
}

export { api };
